import React, { useState } from "react"
import IconButton from "@mui/material/IconButton"
import MoreVertIcon from "@mui/icons-material/MoreVert"
import { Box, ListItemButton } from "@mui/material"
import {
  Checkbox,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Paper,
  Popover,
} from "@material-ui/core"

export default function CustomTableHeaderSelector(props) {
  const { headers, updateHeaders } = props
  const [dropdownOpen, setDropdownOpen] = useState(false)
  const [anchorEl, setAnchorEl] = useState(null)

  const handleClick = (event) => {
    setDropdownOpen(true)
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setDropdownOpen(false)
    setAnchorEl(null)
  }

  const handleToggle = (header, index) => {
    const newHeaders = [...headers]
    if (header.id === newHeaders[index].id && index < newHeaders.length) {
      newHeaders[index].display = !newHeaders[index].display
      updateHeaders(newHeaders)
    }
  }

  return (
    <>
      <IconButton onClick={(event) => handleClick(event)}>
        <MoreVertIcon />
      </IconButton>
      <Popover
        open={dropdownOpen}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        <Paper variant="elevation">
          <Box sx={{ padding: 2 }}>
            <List sx={{ width: "100%", maxWidth: 360, bgcolor: "background.paper" }}>
              {headers.map((header, index) => {
                if (header.id === "image") return null
                const labelId = `checkbox-list-label-${header.id}`
                return (
                  <ListItem key={header.id} disablePadding>
                    <ListItemButton onClick={() => handleToggle(header, index)} dense>
                      <ListItemIcon>
                        <Checkbox
                          edge="start"
                          checked={header.display}
                          tabIndex={-1}
                          disableRipple
                        />
                      </ListItemIcon>
                      <ListItemText id={labelId} primary={header.label} />
                    </ListItemButton>
                  </ListItem>
                )
              })}
            </List>
          </Box>
        </Paper>
      </Popover>
    </>
  )
}
